import * as Sentry from "@sentry/react";


const getEnvironment = () => {
  let isProduction = (process.env.NODE_ENV === 'production' && window.location.hostname.includes("web.myshyft.com"));
  let isStaging = (window.location.hostname.includes("sp3-manager.myshyft.com"));
  return isProduction ? "production" : (isStaging ? "sp3" : "local");
}

Sentry.init({
  dsn: "https://b4a56f538b3d1ce506fc4702fdcde2c0@o117414.ingest.us.sentry.io/4509493322121216",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: getEnvironment(),
  sendDefaultPii: true
});
